import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';


export default function ElectricityBill() {
const[value,setValue]=useState(100);

    function handleSliderChange(event,newValue){
        setValue(newValue)
    }

    const handleInputChange = (event) => {
        let inputValue = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        // inputValue = inputValue ? Math.min(Math.max(parseInt(inputValue, 10), 5), 100) : 0; // Ensure value is within range
        setValue(inputValue);
      };
    return (<>

   
        <div className="flex items-center justify-center px-6">
            <div className="wrapper rounded  mx-auto w-[900px]">
            <h1 className="text-[#1b1763] xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-semibold text-center py-2">
                How much is your average monthly electric bill?
                </h1>
                <p className='md:py-4 py-2 text-center lg:text-xl md:text-lg text-base  font-semibold text-black'>We use this to estimate your usage needs and system size, so your quotes are more accurate. If you aren’t sure, we’ve set the default based on average costs in your area.</p>
            </div>
        </div>

        <div>
        <div className="flex items-center justify-center   mt-2 " >
        <Box className="md:w-[480px] sm:w-[380px] w-[280px]">
  <Slider
  defaultValue={100}
  value={value}
  onChange={handleSliderChange}
  min={100}
  max={10000}
  step={100}
  sx={{
    color: "#f6bc2b", 
  }}
 
  valueLabelDisplay="auto"
  slotProps={{
    valueLabel: {
      sx: {
        backgroundColor: "#434140", 
        color: "#ffffff", 
        fontSize: "14px", 
        borderRadius: "4px", 
        padding: "4px 8px",
        
      },
      
    },
  }}
/>


 
  <div className="flex justify-between -mt-3 mb-4">
    <p className="text-base font-medium text-gray-500">{value} AED</p>
    <p className="text-base font-medium text-gray-500">10,000 AED</p>
  </div>
</Box>

            </div>
        </div>
        <div className="flex items-center justify-center sm:mb-6 mb-4 ">
          
    <div>
      <label for="firstname" className='font-normal text-gray-600 text-base'>Cost per month<span class="text-red-500">*</span></label><br></br>
      <input  
      type="text"
      value={value} // Sync input with slider
      onChange={handleInputChange}
       className="md:text-2xl text-lg  hover:border-[#F6BC29]  md:w-[500px] sm:w-[400px] w-[300px] my-2 md:py-4 py-2 px-6 rounded-2xl bg-white border-2 transition-all duration-300 overflow-hidden cursor-pointer outline-none focus:border-[#F6BC29] focus:shadow-[#F6BC29] focus:shadow-md" placeholder='100 AED' />

      </div>
        </div>

    </>
        
    );
}

